<template>
    <div> 
        <ul v-if="task_type_id >= 2 && task_type_id <= 6">
            <li v-for="(answer,index) in myAnswers" :key="index">
                {{ answer }}
            </li>                                
        </ul>
        <div v-if="task_type_id == 7">
            <div v-for="(answer,index) in myAnswers" :key="index" v-html="answer"></div>
        </div>
        <div v-if="task_type_id >=8 && task_type_id <=10 && myAnswers.length > 0">
            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                <v-tab v-for="(answer, index) in myAnswers" :key="index" @click="tabIndex = index">
                    {{answer.filename}}
                </v-tab>
                <v-spacer></v-spacer>
                <v-icon large style="cursor:pointer" title="Evaluate" @click="evaluate()">done</v-icon>
            </v-tabs>
            <codemirror  class="border-top" 
                v-model="myAnswers[tabIndex].filecontent" 
                :options="getCmOptions(false)"
            />
        </div>
        <div v-if="task_type_id == 16 && myAnswers.length > 0">
            <v-row>
                <v-col cols="7">
                    <v-textarea 
                        label="Answer:"
                        readonly
                        v-model="myAnswers[0]" 
                        rows="8"
                        outlined
                    />
                </v-col>
                
                <v-col cols="5">
                    <v-row>
                        <v-col cols="9">
                            <v-slider
                                min="0"
                                :max="maxScore"
                                v-model="score"                               
                                thumb-label="always"                                
                                ></v-slider>
                        </v-col>
                        <v-col cols="3">
                            <v-btn @click="saveCommentsAndScoreToAttempt()">Save</v-btn>
                        </v-col>
                    </v-row><v-row>
                        <v-col cols="12">
                            <v-textarea 
                                label="Teacher comment:"
                                v-model="myComment" 
                                rows="5"
                                outlined
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

import { codemirror } from "vue-codemirror";
import * as es from "../../assets/editor_settings.js";
import axios from '../,,/../../axios-auth.js'

export default {
    data() {
        return {
            taskContent: {},
            taskOptions: [],
            tabIndex: 0,
            score: 5,
            myComment: ''
        }
    },
    watch: {
        myInfo() {
            this.myComment = this.myInfo
            console.log('aktualizujem')
        },
        curScore() {
            this.score = this.curScore
        },
    },
    props: {
        task_type_id: Number,
        myAnswers: Array,
        myCode: String,
        myInfo: {type: String, required: true},
        maxScore: Number,
        curScore: {type: Number, required: true},
        attID: Number
    },
    components: {
        codemirror
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.score = this.curScore
            this.myComment = this.myInfo
        },
        getCmOptions(_readOnly, _lines = 1, _line_numbers = true) {
            return es.getCmOptionsLines(
                "text/x-python",
                _readOnly,
                _lines,
                _line_numbers
            );
        },
        evaluate()  {
            // console.log(this.myNewAnswers[this.tabIndex].filecontent)
        },
        saveCommentsAndScoreToAttempt() { // for type 16
            // all students lessons
            let _data = {
                attempt_id: this.attID,
                score: this.score,
                comment: this.myComment
            }

            this.$store.commit('setEssayReviewData', _data)
            this.$store.commit('setEssayReviewChanged', true)
        }
    }
}
</script>